import React, { useCallback } from 'react'
import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import XbsngSubmStatusSearchKeys from '../../../constants/locale/key/XbsngSubmStatusSearch'

const XbsngSubmStatusSearchTranslationText = () => {
    const { translate } = useTranslation([
        Namespace.XBSNG_SUBM_STATUS_SEARCH
    ])

    let mblNo = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.MBL_NO)
    let hblNo = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.HBL_NO)
    let filerCode = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.FILER_CODE)
    let refNo = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.REF_NO)
    let msgFunc = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.MSG_FUNC)
    let status = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.STATUS)
    let createdDate = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.CREATED_DATE)
    let transId = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.TRANS_ID)
    let resHblNo = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.RES_HBL_NO)
    let resRefNo = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.RES_REF_NO)
    let resDate = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.RES_DATE)
    let resCode = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.RES_CODE)
    let msgType = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.MSG_TYPE)
    let userId = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.USER_ID)
    let xbsOrgId = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.XBS_ORG_ID)
    let aceOcnXbsngSubmStatusSearchTitle = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.ACE_OCEAN_XBSNG_SUBM_STATUS_SEARCH_TITLE)
    let aceIsfXbsngSubmStatusSearchTitle = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.ACE_ISF_XBSNG_SUBM_STATUS_SEARCH_TITLE)

    //status
    let accepted = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.ACCEPTED)
    let rejected = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.REJECTED)
    let sn = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.SN)
    let sent = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.SENT)
    let sendFailed = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.SEND_FAILED)
    let processing = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.PROCESSING)
    let validationError = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.VALIDATION_ERROR)
    let cancelled = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.CANCELLED)
    let error = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.ERROR)
    let last6Months = translate(Namespace.XBSNG_SUBM_STATUS_SEARCH, XbsngSubmStatusSearchKeys.LAST_6_MONTHS)
    
	return {
        mblNo,
        hblNo,
        filerCode,
        refNo,
        msgFunc,
        status,
        createdDate,
        transId,
        resHblNo,
        resRefNo,
        resDate,
        resCode,
        msgType,
        userId,
        xbsOrgId,
        aceOcnXbsngSubmStatusSearchTitle,
        aceIsfXbsngSubmStatusSearchTitle,
        accepted,
        rejected,
        sn,
        sent,
        sendFailed,
        processing,
        validationError,
        cancelled,
        error,
        last6Months
    }
}

export default XbsngSubmStatusSearchTranslationText